<template>
    <div id="LmTextInputBuilderUi" class="row">
      <LmTextInput
        ref="inputFocus"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.placeholder"
        @input="$emit('input', component)"
        :label="$t('placeholder')"
        :placeholder="$t('placeholder')"
        :help="$t('comp_placeholder_help')"
      />
      <LmTextInput
        class="col-12 col-md-8"
        :id="id + 'help'"
        v-model="component.componentProps.help"
        @input="$emit('input', component)"
        :label="$t('helper_text_setter')"
        :placeholder="$t('helper_text_setter')"
        :help="$t('helper_text_setter_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <hr class="w-100 mx-2">
      <div class="col-12">
        <h5>{{ $t('validations') }}</h5>
        <div class="row align-items-center">
          <LmCheckbox
            class="col-12 col-md-4"
            :labelSingle="$t('required')"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
          />
          <LmCheckbox
            class="col-12 col-md-4"
            :labelSingle="$t('email')"
            v-model="validations.email"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
          />
        </div>
      </div>
      <hr class="w-100 mx-2">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        email: false
      }
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    // Cada vez que actualizo el name, recargo las validaciones con el nuevo name
    'component.formObjectToSendToServerProperty' (newVal) {
      this.$emit('validations-changes', { [newVal]: this.validations })
    }
  },
  created () {
    /*
      En el Mixin LmFormElementsBuilderUiMixin.js pisa el data de este
      componente impidiendo setear las variables por defecto.
      Lo soluciono con este bloque para que la validacion "email" este checked por defecto.
    */
    if (!this.validations.hasOwnProperty('email')) {
      this.validations.email = true
      this.$emit('validations-changes', { [this.component.formObjectToSendToServerProperty]: this.validations })
    }
  }
}
</script>
